<template>
  <div class="statistical-analysis wrap m-background">
    <div class="query-array">
      <div class="left-query">
        <query-obj
            v-for='searchQuery in config.queryList'
            v-if="!searchQuery.isHide"
            :key='searchQuery.name'
            :search='searchQuery'
            @setSearchValueChange='setSearchValueChange'
            @enterSearch="enterSearch"
        >
        </query-obj>
      </div>
      <div class="right-oper hidden-xs" style="width: 60px;">
        <Button type="primary" @click="fetchList()">查询</Button>
      </div>
    </div>
    <div class="action-array">
      <Button type="primary" @click="clickExportBtn()">导出</Button>
    </div>
    <div class="query-result">
      <query-table
          :loading="loading"
          :head-config="titles[searchParam.url]"
          :legent="[]"
          :rows="rows"
      ></query-table>
    </div>
    <div class="query-result-chart" v-if="!config.queryList[4].isHide">
      <div id="resultChart"></div>
    </div>
  </div>
</template>

<script>
import QueryObj from '@/components/regularQuery/queryObj'
import QueryTable from '@/components/table/regularTable.vue'

export default {
  name: 'StatisticalAnalysis',
  components: {QueryObj, QueryTable},
  data () {
    return {
      config: {
        queryList: [
          {
            name: 'year',
            label: '送审年份',
            notNull: true,
            component: 'select',
            componentAttr: {
              options: []
            }
          },
          {
            name: 'quarter',
            label: '送审季度',
            notNull: true,
            component: 'select',
            componentAttr: {
              options: [
                {
                  value: '第一季度',
                  label: '第一季度'
                },
                {
                  value: '第二季度',
                  label: '第二季度'
                },
                {
                  value: '第三季度',
                  label: '第三季度'
                },
                {
                  value: '第四季度',
                  label: '第四季度'
                }
              ]
            }
          },
          {
            name: 'url',
            label: '统计类型',
            notNull: true,
            component: 'select',
            value: 'sendData',
            labelValue: '送审数据分析',
            componentAttr: {
              options: [
                {
                  value: 'sendData',
                  label: '送审数据分析'
                },
                {
                  value: 'unitType',
                  label: '评审单位类型分析'
                },
                {
                  value: 'unit',
                  label: '评审单位占比分析'
                },
                {
                  value: 'evaluation',
                  label: '总体评价占比分析'
                },
                {
                  value: 'reviewResult',
                  label: '答辩意见数据分析'
                },
                {
                  value: 'familiarLevel',
                  label: '专家领域熟悉程度分析'
                },
                {
                  value: 'differentData',
                  label: '分歧成绩数据分析'
                }
              ]
            }
          },
          {
            name: 'degreeType',
            label: '学位类型',
            isHide: true,
            notNull: true,
            component: 'select',
            request: {
              method: 'post',
              addr: '/conf/confDegreeType/queryDegreeTypeList',
              data: {},
              format: {
                value: 'id',
                label: 'name'
              }
            }
          },
          {
            name: 'chartType',
            label: '展示方式',
            isHide: true,
            notNull: true,
            component: 'select',
            value: 'pie',
            labelValue: '饼图',
            componentAttr: {
              options: [
                {
                  value: 'pie',
                  label: '饼图'
                },
                {
                  value: 'bar',
                  label: '柱状图'
                },
                {
                  value: 'line',
                  label: '折线图'
                }
              ]
            }
          }
        ]
      },
      titles: {
        'sendData': [
          {
            name: 'count',
            label: '送审数量'
          },
          {
            name: 'academyCount',
            label: '涉及院系'
          },
          {
            name: 'firstSubjectCount',
            label: '涉及一级学科'
          },
          {
            name: 'secondSubjectCount',
            label: '涉及二级学科'
          }
        ],
        'unitType': [
          {
            name: 'schoolType',
            label: '评审单位类型'
          },
          {
            name: 'count',
            label: '评审单位数量'
          },
          {
            name: 'schoolTypePercent',
            label: '评审单位占比'
          }
        ],
        'unit': [
          {
            name: 'schoolName',
            label: '评审单位'
          },
          {
            name: 'count',
            label: '评审数量'
          },
          {
            name: 'schoolPercent',
            label: '评审占比'
          }
        ],
        'evaluation': [
          {
            label: '学位类型',
            name: 'degree'
          },
          {
            label: '总体评价',
            name: 'evaluation'
          },
          {
            label: '数量',
            name: 'count'
          },
          {
            label: '占比',
            name: 'evaluationPercent'
          }
        ],
        'reviewResult': [
          {
            label: '学位类型',
            name: 'degree'
          },
          {
            label: '答辩意见',
            name: 'reviewResult'
          },
          {
            label: '数量',
            name: 'count'
          },
          {
            label: '占比',
            name: 'reviewPercent'
          }
        ],
        'familiarLevel': [
          {
            label: '学位类型',
            name: 'degree'
          },
          {
            label: '熟悉程度',
            name: 'familiarLevel'
          },
          {
            label: '数量',
            name: 'count'
          },
          {
            label: '占比',
            name: 'familiarLevelPercent'
          }
        ],
        'differentData': [
          {
            name: 'academyName',
            label: '学院名称'
          },
          {
            name: 'authorName',
            label: '学生姓名'
          },
          {
            name: 'schoolNo',
            label: '学号'
          },
          {
            name: 'familiarLevel',
            label: '熟悉程度'
          },
          {
            name: 'evaluation',
            label: '总体评价'
          }
        ]
      },
      url: {
        'sendData': {
          searchUrl: '/school/statistics/sendData',
          exportUrl: '/school/statistics/exportSendData'
        },
        'unitType': {
          searchUrl: '/school/statistics/unitType',
          exportUrl: '/school/statistics/exportUnitType'
        },
        'unit': {
          searchUrl: '/school/statistics/unit',
          exportUrl: '/school/statistics/exportUnit'
        },
        'evaluation': {
          searchUrl: '/school/statistics/evaluation',
          exportUrl: '/school/statistics/exportEvaluation'
        },
        'reviewResult': {
          searchUrl: '/school/statistics/reviewResult',
          exportUrl: '/school/statistics/exportReview'
        },
        'familiarLevel': {
          searchUrl: '/school/statistics/familiarLevel',
          exportUrl: '/school/statistics/exportFamiliar'
        },
        'differentData': {
          searchUrl: '/school/statistics/differentData',
          exportUrl: '/school/statistics/exportDifferent'
        }
      },
      searchParam: {
        url: 'sendData',
        year: '',
        quarter: '',
        chartType: 'pie'
      },
      chart: null,
      rows: [],
      loading: false
    }
  },
  created () {
    const _self = this;
    // 初始化年份
    let curYear = new Date().getFullYear();
    let year = curYear;
    while (year >= curYear - 5) {
      _self.config.queryList[0].componentAttr.options.push(
        {
          value: '' + year,
          label: year + '年'
        }
      )
      year--;
    }
    _self.searchParam.year = '' + curYear;
    _self.config.queryList[0].value = '' + curYear;
    _self.config.queryList[0].labelValue = curYear + '年';
    // _self.config.queryList[0].componentAttr.options[0].checked = true;

    // 初始化季度
    let month = new Date().getMonth();
    // _self.config.queryList[1].componentAttr.options[parseInt(month / 3)].checked = true;
    _self.config.queryList[1].value = _self.config.queryList[1].componentAttr.options[parseInt(month / 3)].value;
    _self.config.queryList[1].labelValue = _self.config.queryList[1].componentAttr.options[parseInt(month / 3)].label;
    _self.searchParam.quarter = _self.config.queryList[1].componentAttr.options[parseInt(month / 3)].value;

    _self.fetchList();
  },
  watch: {
    'searchParam.chartType': function (val) {
      this.drawChart();
    }
  },
  methods: {
    fetchList () {
      const _self = this;
      _self.loading = true;
      _self.$Loading.start();
      let param = {};
      param.year = _self.searchParam.year;
      param.quarter = _self.searchParam.quarter;
      if (_self.searchParam.url === 'evaluation' || _self.searchParam.url === 'reviewResult' || _self.searchParam.url === 'familiarLevel') {
        param.degreeType = _self.searchParam.degreeType;
      }
      _self.post(_self.url[_self.searchParam.url].searchUrl, param).then(res => {
        let result = res.data;
        if (typeof result === 'string') {
          result = JSON.parse(result);
        }
        if (_self.searchParam.url === 'sendData') {
          _self.rows = [result];
        } else if (_self.searchParam.url === 'evaluation' || _self.searchParam.url === 'reviewResult' || _self.searchParam.url === 'familiarLevel') {
          _self.rows = [];
          for (let item of result) {
            for (let i of item.list) {
              i.degree = item.degree.name;
              _self.rows.push(i);
            }
          }
        } else {
          _self.rows = result;
        }
        setTimeout(() => {
          _self.drawChart();
        });
        _self.$Loading.finish();
        _self.loading = false;
      }).catch(() => {
        _self.$Loading.error();
        _self.loading = false;
      });
    },
    enterSearch () {
    },
    // 条件筛选框设置
    setSearchValueChange (curObj) {
      this.searchParam[curObj.name] = curObj.value;
      if (curObj.name === 'url') {
        this.config.queryList[4].isHide = curObj.value === 'sendData' || curObj.value === 'differentData';

        let before = this.config.queryList[3].isHide;
        this.config.queryList[3].isHide = !(curObj.value === 'evaluation' || curObj.value === 'reviewResult' || curObj.value === 'familiarLevel');

        if (!(before && !this.config.queryList[3].isHide)) {
          this.fetchList();
        }
      } else if (curObj.name !== 'chartType') {
        this.fetchList();
      }
    },
    // 导出
    clickExportBtn () {
      const _self = this;
      _self.post(_self.url[_self.searchParam.url].exportUrl, _self.searchParam).then(res => {
        let url = res.data
        setTimeout(() => {
          window.open(url)
        }, 500);
      });
    },
    drawChart () {
      const _self = this;
      if (_self.chart) _self.chart.dispose();
      if (_self.config.queryList[4].isHide) return;

      let title = _self.config.queryList[2].componentAttr.options.filter(item => item.value === _self.searchParam.url);
      title = title[0].label;

      _self.chart = echarts.init(document.getElementById('resultChart'), 'cndatahub');
      _self.chart.showLoading();

      let legendData = [];
      let seriesData = []
      let lineData = [];
      if (_self.searchParam.url === 'unitType') {
        for (let item of _self.rows) {
          legendData.push(item.schoolType);
          seriesData.push({
            name: item.schoolType,
            value: item.count
          });
          lineData.push(item.count);
        }
      } else if (_self.searchParam.url === 'unit') {
        for (let item of _self.rows) {
          legendData.push(item.schoolName);
          seriesData.push({
            name: item.schoolName,
            value: item.count
          });
          lineData.push(item.count);
        }
      } else {
        for (let item of _self.rows) {
          legendData.push(item[_self.searchParam.url]);
          seriesData.push({
            name: item[_self.searchParam.url],
            value: item.count
          });
          lineData.push(item.count);
        }
      }
      if (_self.searchParam.chartType === 'pie') {
        _self.chart.setOption(_self.drawPieGraph(title, legendData, seriesData))
      } else {
        _self.chart.setOption(_self.drawLineBarGraph(_self.searchParam.chartType, title, legendData, lineData));
      }
      _self.chart.hideLoading();
    },
    // 画饼图
    drawPieGraph (title, legendData, seriesData) {
      return {
        title: {
          text: title,
          x: '20'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 20,
          top: 20,
          bottom: 20,
          data: legendData
        },
        series: [
          {
            name: title,
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: seriesData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
    },
    drawLineBarGraph (type, title, legendData, seriesData) {
      return {
        title: {
          text: title,
          x: '20'
        },
        xAxis: {
          type: 'category',
          data: legendData
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: title,
          label: {
            normal: {
              show: true
            }
          },
          data: seriesData,
          type: type
        }]
      };
    }
  }
}
</script>

<style lang="less" scoped>
.statistical-analysis {
  .query-result-chart {
    height: 400px;
    width: 100%;
    #resultChart {
      height: 100%;
      width: 100%;
    }
  }
}
.m-background {
  background-color:#fff;
  border-radius:4px;
  width:calc(100% - 20px);
  margin-left:10px;
  padding-top: 10px;
}
</style>
<style>
.kh-table-border:before {
  height: 0 !important;
}
.kh-table-border:after {
  height: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/customPage/statisticalAnalysis/index.vue